export class User {
  private alias = null;

  private sso: boolean = false;

  constructor(public username: string, public password: string) {}

  public RemoteClass() {
    return this.alias;
  }

  public getUsername(): string {
    return this.username;
  }
  public getPassword(): string {
    return this.password;
  }

  public isSSO(): boolean {
    return this.sso;
  }

  public setSSO(sso: boolean) {
    this.sso = sso;
  }

  public clone(): User {
    let u: User = new User(this.username, this.password);
    u.sso = this.isSSO();
    return u;
  }
}
